export default "__VITE_ASSET__CDosGYmm__"